
export class Category {
  public name: string;
  public id: string;
  public categoryID: number;
  public isParent: boolean;
  public isActive: boolean;
  public isShow: boolean;
  public isChecked: boolean;
  public categoryName: string;
  public parentCategoryID: number;
  public detail: string;
  public url: string;
  public tinyImage: string;
  public smallImage: string;
  public largeImage: string;
  public sortOrder: number;
  public createdBy: number;
  public createdBy_id: string;
  public createdDate: Date;
  public updatedBy: number;
  public updatedBy_id: string;
  public updatedDate: Date;
  public metaTitle: string;
  public metaTag: string;
  public metaDescription: string;
  public iconClass: string;
  public justForU: boolean; 
}



// WEBPACK FOOTER //
// ./src/app/models/category/category.model.ts